




import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})
export default class Home extends Vue {
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue